import RewardsScreen from 'src/components/screens/RewardsScreen';
import RewardsLegacyScreen from 'src/components/screens/RewardsLegacyScreen';
import AccountStore from 'src/stores/AccountStore';
import {NavigationProp, RouteProp} from '@react-navigation/native';
import PersistentStore from 'src/services/PersistentStoreService';

const withScreenData = (GMARewardsScreen, LegacyRewardsScreen) => {
  return (props: {navigation: NavigationProp<any>; route: RouteProp<any>}) => {
    let _status = AccountStore.getRewardStatus();
    let _rProducts = AccountStore.getRewardProducts();
    /**If accountstore does not have any data, then try to get it from persistent store */
    if (_status && _status?.rewardTier && _status?.rewardStatuses) {
      PersistentStore.getRewardsResponse().then((storage) => {
        if (storage) {
          _status = storage;
        }
      });
    }
    if (_rProducts && _rProducts?.rewardProducts) {
      PersistentStore.getRewardProductsResponse().then((storage) => {
        if (storage) {
          _rProducts = storage;
        }
      });
    }

    if (
      _status &&
      _status?.rewardTier &&
      _status?.rewardStatuses &&
      _rProducts &&
      _rProducts?.rewardProducts
    ) {
      return <GMARewardsScreen {...props} />;
    } else if (AccountStore.getAccountRewards() > 0 || AccountStore.isDemo()) {
      return <LegacyRewardsScreen {...props} />;
    } else {
      return <></>;
    }
  };
};

export const RewardsTabScreenWithHOC = withScreenData(
  RewardsScreen,
  RewardsLegacyScreen,
);
